import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, ThemeSpaces } from '../../../theme';

export const useQuoteFlightItineraryStyles = createStyles(({ token }) => ({
  itineraryCard: {
    whiteSpace: 'nowrap',
  },
  airlineLogo: {
    width: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: `0 ${ThemeSpaces.SPACE_SM}px 0 ${ThemeSpaces.SPACE_XS}px`,
  },
  itineraryValue: {
    color: ThemeColors.COLOR_GREY3,
    fontFamily: token.fontFamily,
    fontSize: token.fontSize,
    fontWeight: 500,

    [`@media (max-width: ${token.screenXLMax}px)`]: {
      fontSize: token.fontSizeSM,
    },
    [`@media (max-width: ${token.screenSMMax}px)`]: {
      fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
    },
  },
  verticalSeparator: {
    height: 45,
    margin: '0 auto',
    backgroundColor: ThemeColors.COLOR_GREY7,
  },
  flightItinerarySchedules: {
    paddingLeft: 32,

    [`@media (min-width: ${token.screenMDMin}px)`]: {
      paddingLeft: 0,
    },
  },
}));
